import type { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/pagination';

import 'swiper/css/effect-fade';

interface gallerySwiperProps {
  images: Array<string>;
}

const GallerySwiper: FC<gallerySwiperProps> = ({ images }) => {
  return (
    <div className="relative">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        pagination={{
          el: '#swiper-pagination',
          type: 'bullets',
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active',
          clickable: true,
        }}
        effect="fade"
        autoplay={{ delay: 2000 }}
        loop={true}
        speed={1000}
        modules={[Pagination, Autoplay, EffectFade]}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full h-[300px] overflow-hidden rounded-sm md:h-[420px] lg:h-[560px]">
              <img
                className="absolute top-0 left-0 object-cover object-center w-full h-full"
                src={image}
                alt={`${process.env.REACT_APP_COMPANY_NAME} library`}
              />
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-text/80 via-text/30 to-accent/20" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="absolute z-10 w-full bottom-8">
        <div id="swiper-pagination"></div>
      </div>
    </div>
  );
};
export default GallerySwiper;
